/**
 * The project logo cached in localStorage. A tenant without a logo used to be cached as the literal strings "null" /
 * "undefined", which then rendered as `<img src="null">` (GET /null 404); treat those as "no logo".
 */
export function getStoredProjectLogo(): string | null {
  const value = localStorage.getItem('projectLogo')?.trim();
  return value && value !== 'null' && value !== 'undefined' ? value : null;
}

export function storeProjectLogo(logo: string | null | undefined): void {
  if (logo) localStorage.setItem('projectLogo', logo);
  else localStorage.removeItem('projectLogo');
}
